// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-left,
.team-right {
  padding-top: 120px;
}

.team-left {
  background-color: #6b737e;
}

@media screen and (min-width: 786px) {
  .team {
    padding-right: 50px;
  }
}
@media screen and (max-width: 991px) {
  .team {
    padding-left: 70px;
    padding-right: 70px;
    padding-top: 100px;
  }
  .team .person {
    height: 250px !important;
    padding-left: 0;
    padding-right: 0;
  }
}
a {
  color: black;
}

h2 {
  width: 100%;
  text-align: center;
  padding: 30px;
  padding-top: 0;
  padding-bottom: 50px;
}

.person {
  cursor: pointer;
  min-height: 300px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  margin-bottom: 50px;
  padding-left: 0;
  padding-right: 0;
}
.person h3 {
  margin-bottom: 20px;
  font-size: 1.2em !important;
  text-decoration: none;
}
@media screen and (max-width: 1800px) {
  .person h3 {
    font-size: 0.9em !important;
    min-height: 35px;
  }
}
@media screen and (max-width: 1300px) {
  .person h3 {
    min-height: 60px;
  }
}
.person .noPadding {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.details {
  padding: 0;
}
.details h4 {
  font-size: 1em !important;
  display: inline-block;
  min-height: 80px;
}
.details .country {
  float: right;
  margin-right: 14px;
}
.details .country img {
  margin-top: -40px;
  position: absolute;
  right: 0;
  padding-right: 14px;
}

@media screen and (max-width: 1800px) {
  .country {
    position: absolute;
    margin-right: 0;
    display: block;
    width: 100%;
    right: 0;
    top: 50px;
  }
  .country img {
    margin-top: 0;
    padding-right: 0 !important;
    bottom: 0;
  }
}
.personimg {
  overflow: hidden;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
  position: relative;
  height: 185px;
  width: 100%;
  background-size: cover !important;
  background-position: center 20% !important;
}

.teamSwitch {
  position: absolute;
  top: 80px;
  right: 0;
  padding: 5px;
  background-color: #e1e1e1;
  margin-bottom: 5px;
}
.teamSwitch div {
  background-color: #e1e1e1;
  position: relative;
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
}
.teamSwitch .grid img {
  position: relative;
  top: 3px;
}
.teamSwitch .listicon img {
  position: relative;
  top: 5px;
}
.teamSwitch .selected {
  background-color: white;
  border: 3px solid #FFFFE4;
}

.coverImgContainer {
  width: 160px;
  cursor: pointer;
  padding-left: 30px;
}
.coverImgContainer img {
  width: 100%;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/team/team.component.scss"],"names":[],"mappings":"AAAE;;EAEE,kBAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE;EACE;IACE,mBAAA;EACJ;AACF;AAGE;EACE;IACE,kBAAA;IACA,mBAAA;IACA,kBAAA;EADJ;EAGI;IACE,wBAAA;IACA,eAAA;IACA,gBAAA;EADN;AACF;AAME;EACE,YAAA;AAJJ;;AAQE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;AALJ;;AAQE;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AALJ;AAOI;EACE,mBAAA;EACA,2BAAA;EACA,qBAAA;AALN;AASI;EACE;IACE,2BAAA;IACA,gBAAA;EAPN;AACF;AAUI;EACE;IACE,gBAAA;EARN;AACF;AAcI;EACE,0BAAA;EACA,2BAAA;AAZN;;AAiBE;EACE,UAAA;AAdJ;AAgBI;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;AAdN;AAiBI;EAEE,YAAA;EACA,kBAAA;AAhBN;AAkBM;EACE,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;AAhBR;;AAuBE;EAEE;IACE,kBAAA;IACA,eAAA;IACA,cAAA;IACA,WAAA;IAEA,QAAA;IACA,SAAA;EAtBJ;EA0BI;IACE,aAAA;IACA,2BAAA;IACA,SAAA;EAxBN;AACF;AA8BE;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,iCAAA;EACA,0CAAA;AA5BJ;;AAiCE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AA9BJ;AAiCI;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AA/BN;AAmCM;EACE,kBAAA;EACA,QAAA;AAjCR;AAuCM;EACE,kBAAA;EACA,QAAA;AArCR;AA0CI;EACE,uBAAA;EACA,yBAAA;AAxCN;;AA4CE;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AAzCJ;AA2CI;EACE,WAAA;EACA,aAAA;AAzCN","sourcesContent":["  .team-left,\r\n  .team-right {\r\n    padding-top: 120px;\r\n  }\r\n\r\n  .team-left {\r\n    background-color: #6b737e;\r\n  }\r\n\r\n  @media screen and (min-width:786px) {\r\n    .team {\r\n      padding-right: 50px;\r\n    }\r\n  }\r\n\r\n  //Smaller than, ex LG > breakpoint\r\n  @media screen and (max-width:991px) {\r\n    .team {\r\n      padding-left: 70px;\r\n      padding-right: 70px;\r\n      padding-top: 100px;\r\n\r\n      .person {\r\n        height: 250px !important;\r\n        padding-left: 0;\r\n        padding-right: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  a {\r\n    color: black;\r\n  }\r\n\r\n\r\n  h2 {\r\n    width: 100%;\r\n    text-align: center;\r\n    padding: 30px;\r\n    padding-top: 0;\r\n    padding-bottom: 50px;\r\n  }\r\n\r\n  .person {\r\n    cursor: pointer;\r\n    min-height: 300px;\r\n    background-color: rgba(255, 255, 255, .9);\r\n    padding: 20px;\r\n    margin-bottom: 50px;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n\r\n    h3 {\r\n      margin-bottom: 20px;\r\n      font-size: 1.2em !important;\r\n      text-decoration: none;\r\n\r\n    }\r\n\r\n    @media screen and (max-width: 1800px) {\r\n      h3 {\r\n        font-size: .9em !important;\r\n        min-height: 35px;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width:1300px) {\r\n      h3 {\r\n        min-height: 60px;\r\n      }\r\n    }\r\n\r\n\r\n\r\n\r\n    .noPadding {\r\n      padding-left: 0 !important;\r\n      padding-right: 0 !important;\r\n    }\r\n\r\n  }\r\n\r\n  .details {\r\n    padding: 0;\r\n\r\n    h4 {\r\n      font-size: 1em !important;\r\n      display: inline-block;\r\n      min-height: 80px;\r\n    }\r\n\r\n    .country {\r\n\r\n      float: right;\r\n      margin-right: 14px;\r\n\r\n      img {\r\n        margin-top: -40px;\r\n        position: absolute;\r\n        right: 0;\r\n        padding-right: 14px;\r\n      }\r\n    }\r\n\r\n\r\n  }\r\n\r\n  @media screen and (max-width:1800px) {\r\n\r\n    .country {\r\n      position: absolute;\r\n      margin-right: 0;\r\n      display: block;\r\n      width: 100%;\r\n\r\n      right: 0;\r\n      top: 50px;\r\n\r\n\r\n\r\n      img {\r\n        margin-top: 0;\r\n        padding-right: 0 !important;\r\n        bottom: 0;\r\n      }\r\n\r\n    }\r\n\r\n  }\r\n\r\n  .personimg {\r\n    overflow: hidden;\r\n    text-align: center;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-bottom: 15px;\r\n    position: relative;\r\n    height: 185px;\r\n    width: 100%;\r\n    background-size: cover !important;\r\n    background-position: center 20% !important;\r\n  }\r\n\r\n\r\n  //Mobile\r\n  .teamSwitch {\r\n    position: absolute;\r\n    top: 80px;\r\n    right: 0;\r\n    padding: 5px;\r\n    background-color: #e1e1e1;\r\n    margin-bottom: 5px;\r\n\r\n\r\n    div {\r\n      background-color: #e1e1e1;\r\n      position: relative;\r\n      display: inline-block;\r\n      padding-left: 5px;\r\n      padding-right: 5px;\r\n    }\r\n\r\n    .grid {\r\n      img {\r\n        position: relative;\r\n        top: 3px;\r\n      }\r\n\r\n    }\r\n\r\n    .listicon {\r\n      img {\r\n        position: relative;\r\n        top: 5px;\r\n      }\r\n\r\n    }\r\n\r\n    .selected {\r\n      background-color: white;\r\n      border: 3px solid #FFFFE4;\r\n    }\r\n  }\r\n\r\n  .coverImgContainer {\r\n    width: 160px;\r\n    cursor: pointer;\r\n    padding-left: 30px;\r\n\r\n    img {\r\n      width: 100%;\r\n      padding: 10px;\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
